import { PROGRESS } from '../../config/config';

export const notificationProperties = {
  BLIK: {
    default: {
      fromProgress: PROGRESS.SELECT_BLIK_METHOD,
      toProgress: PROGRESS.BLIK_CODE_VERIFICATION,
      notification: 'statusBar.paymentNotification.blik.default.message',
      notificationBold: 'statusBar.paymentNotification.blik.default.messageBold',
    },
    levelZero: {
      fromProgress: PROGRESS.SELECT_BLIK_METHOD,
      toProgress: PROGRESS.BLIK_CODE_VERIFICATION,
      notification: 'statusBar.paymentNotification.blik.default.message',
      notificationBold: 'statusBar.paymentNotification.blik.levelZero.messageBold',
    },
  },
  PBL: {
    default: {
      fromProgress: PROGRESS.SELECT_PBL_BANK,
      toProgress: PROGRESS.SELECT_PBL_BANK,
      notification: 'statusBar.paymentNotification.psd2.default.message',
      notificationBold: 'statusBar.paymentNotification.psd2.default.messageBold',
    },
  },
};

export type PaymentNotificationProperties = {
  default: NotificationProperties;
  levelZero?: NotificationProperties;
};

export type NotificationProperties = {
  fromProgress: number;
  toProgress: number;
  notification?: string;
  notificationBold?: string;
};

export const disabledPaymentMethodNotification = {
  fromProgress: PROGRESS.NOT_SELECTED_PAYMENT_METHOD,
  toProgress: PROGRESS.NOT_SELECTED_PAYMENT_METHOD,
  notification: 'paymentNotification.method.disabled.default.methodDisabled.message',
  notificationBold: 'paymentNotification.method.disabled.default.methodDisabled.messageBold',
};

export const unsupportedApplePayPaymentMethodNotification = {
  fromProgress: PROGRESS.NOT_SELECTED_PAYMENT_METHOD,
  toProgress: PROGRESS.NOT_SELECTED_PAYMENT_METHOD,
  notification: 'paymentNotification.method.disabled.applePay.methodDisabled.message',
  notificationBold: 'paymentNotification.method.disabled.applePay.methodDisabled.messageBold',
};

export const getDefaultPaymentNotificationSettings = (
  paymentMethodType: string,
  isLevelZero: boolean
): NotificationProperties | undefined => {
  const notificationSettings: PaymentNotificationProperties = notificationProperties[paymentMethodType]
    ? notificationProperties[paymentMethodType]
    : undefined;
  if (notificationSettings === undefined) return undefined;
  if (isLevelZero)
    return notificationSettings.levelZero ? notificationSettings.levelZero : notificationSettings.default;
  return notificationSettings.default;
};
